<!-- View -->
<div class="d-flex mx-2 px-2 align-items-center">
  <div
    id="{{ view().name }}"
    class="col cursorpointer p-2"
    [ngClass]="{
      'text-primary': view().name === active()?.name
    }"
    (click)="select()"
    >
    {{ view().title }}
  </div>
  @if (view().isDefault === false) {
    <div class="col-auto">
      @if (view().name === active()?.name) {
        <button
          kendoButton
          class="px-2 py-1"
          fillMode="clear"
          rounded="small"
          (click)="update()"
          >
          <i class="fa-regular fa-save"></i>
        </button>
      }
      @if (view().name !== active()?.name) {
        <button
          kendoButton
          class="px-2 py-1"
          fillMode="clear"
          rounded="small"
          (click)="toggleDialog()"
          >
          <i class="fa-regular fa-trash-can"></i>
        </button>
      }
    </div>
  }
</div>

<!-- Delete view dialog -->
@if (showConfirm) {
  <kendo-dialog
    [title]="'HOME_COMPONENTS.VIEW_ITEM.DELETE_VIEW_TITLE' | translate"
    (close)="toggleDialog()"
    [minWidth]="250"
    autoFocusedElement="#dialogBody"
    [width]="450"
    >
    <div class="d-grid mx-6 p-3" id="dialogBody">
      <p class="text-center">
        {{ 'HOME_COMPONENTS.VIEW_ITEM.DELETE_VIEW_CONFIRM' | translate : { title: view().title } }}
      </p>
    </div>
    <kendo-dialog-actions [layout]="'end'">
      <button kendoButton [size]="'small'" (click)="toggleDialog()">
        {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
      </button>
      <button
        kendoButton
        (click)="confirm()"
        [size]="'small'"
        themeColor="primary"
        >
        {{ 'HOME_COMPONENTS.COMMON.DELETE' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
